import { useContext } from 'react';
import DefaultPortalContext, { PortalContext } from './DefaultPortalContext';
export default (): PortalContext => useContext(DefaultPortalContext);